/**
 * Documents (DMS) route — the standalone document repository.
 *
 * Save / organise / find: folders, tags, search, upload, preview/download,
 * soft-delete. Visible to all workspace members. Backed by `documents.*`.
 *
 * @see packages/db/migrations/0096_documents.sql
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../features/workspace/index.ts";
import { DocumentsPage } from "../../../features/documents/index.ts";

export const Route = createFileRoute("/(workspace)/documents/")({
  component: DocumentsRoute,
});

function DocumentsRoute() {
  return (
    <WorkspaceShell breadcrumbs={[{ label: "Documents" }]}>
      <DocumentsPage />
    </WorkspaceShell>
  );
}
